export function isIntranetUser(value: unknown): boolean {
  return value === true || value === 1 || value === "1";
}

export function hasInternalDomainAccount(user?: {
  is_intr?: unknown;
  bind_360?: unknown;
  has_internal_domain_account?: unknown;
} | null): boolean {
  return isIntranetUser(user?.is_intr) && Boolean(user?.bind_360);
}

export function canViewDomainIdentity(user?: {
  is_intr?: unknown;
} | null): boolean {
  return isIntranetUser(user?.is_intr);
}
